import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationType } from '../api';

const getNotificationType = (type: NotificationType) => {
    const { t } = useTranslation(['notifications']);

    return useMemo(() => {
        switch (type) {
            case NotificationType.SignUpApproval:
                return t('notifications:types.signUpApproval');
            case NotificationType.SignUpReject:
                return t('notifications:types.signUpReject');
            case NotificationType.UpcomingBiddingNotice:
                return t('notifications:types.upcomingBidding');
            case NotificationType.AwardedNotice:
                return t('notifications:types.awardedNotice');
            case NotificationType.AwardedNoticeToSc:
                return t('notifications:types.awardedNoticeToSC');

            case NotificationType.BidPeriodChanges:
                return t('notifications:types.bidPeriodChanges');

            case NotificationType.DealersOvertakenByHigherBid:
                return t('notifications:types.higherOfferNotification');

            case NotificationType.BidSubmissionConfirmation:
                return t('notifications:types.bidSubmissionConfirmation');

            case NotificationType.HighestOfferNotification:
                return t('notifications:types.highestOfferNotification');

            default:
                return '';
        }
    }, [type, t]);
};

export default getNotificationType;
